module.exports = __webpack_public_path__ + "img/DNS.ebe244b.svg";